Shop.store.mutations = {
    setFilterExpanded(state, value) {
        state.filterExpanded = value;
    },
    setPaymentStatus(state, value) {
        setTimeout(function() {
            state.paymentStatus = value;
        }, 2000);
    }
};